import { render, staticRenderFns } from "./HtmlBlock.vue?vue&type=template&id=1a52bccc"
import script from "./HtmlBlock.vue?vue&type=script&lang=js"
export * from "./HtmlBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports